import { FormContentBlock } from "components/common/FormContentBlock";
import React, { Dispatch, SetStateAction } from "react";
import { Form, Spinner } from "react-bootstrap";
import { ElectricityPackageUnion, UpdateElectricityAgreementRenewalPlanModalForm } from "../modals/UpdateElectricityAgreementRenewalPlanModal";
import { ContractPeriod } from "components/ElectricityPackages/models";
import UpdateElectricityAgreementRenewalPlanConsumptionPriceForm from "./UpdateElectricityAgreementRenewalPlanConsumptionPriceForm";
import UpdateElectricityAgreementRenewalPlanPackageForm from "./UpdateElectricityAgreementRenewalPlanPackageForm";
import UpdateElectricityAgreementRenewalPlanProductionPriceForm from "./UpdateElectricityAgreementRenewalPlanProductionPriceForm";

interface UpdateElectricityAgreementRenewalPlanDataProps {
    form: UpdateElectricityAgreementRenewalPlanModalForm;
    setForm: Dispatch<SetStateAction<UpdateElectricityAgreementRenewalPlanModalForm>>;
    packages: ElectricityPackageUnion[];
    contractPeriods: ContractPeriod[];
    isLoading: boolean;
}

export default function UpdateElectricityAgreementRenewalPlanData(
    { form, setForm, packages, contractPeriods, isLoading }:
    UpdateElectricityAgreementRenewalPlanDataProps
) {

    return (
        <Form className="change-electricity-agreement-package__container" noValidate validated={form.validated}>
            <FormContentBlock title="Pakett">
                {
                   isLoading ? (
                    <div style={{height : "200px"}} className="d-flex justify-content-center align-items-center">
                        <Spinner size="sm" animation="border"/>
                    </div>
                   ) : (
                    <UpdateElectricityAgreementRenewalPlanPackageForm 
                        form={form}
                        setForm={setForm}
                        packages={packages}
                        contractPeriods={contractPeriods}
                    />
                   )
                }
            </FormContentBlock>
            <FormContentBlock title="Müügihind">
                {
                   isLoading ? (
                    <div style={{height : "250px"}} className="d-flex justify-content-center align-items-center">
                        <Spinner size="sm" animation="border"/>
                    </div>
                   ) : (
                    <UpdateElectricityAgreementRenewalPlanConsumptionPriceForm 
                        form={form}
                        setForm={setForm}
                    />
                   )
                }
            </FormContentBlock>
            {
                form.hasProduction && (
                    <FormContentBlock title="Ostuhind">
                        <UpdateElectricityAgreementRenewalPlanProductionPriceForm 
                            form={form}
                            setForm={setForm}
                        />
                    </FormContentBlock>
                )
            }
        </Form>

    )
}